<!-- 流量中心首页 -->
<!-- 流量中心首页 -->
<template>
    <div class="acout">
        <div class="acout-title">
            <div class="title ">流量中心</div>
            <span @click="handleLog">变更记录<i class="el-icon-arrow-right"></i></span>
        </div>
        <el-row>
            <el-col :span="7">
                <!-- 进度条 -->
                <div class="acout-progress">
                    <div class="acout-progress-item">
                        <span>已使用：{{ConsumeInfo.use}}GB/{{ConsumeInfo.total}}GB
                            <span>
                                <el-popover placement="top" width="400" trigger="hover">
                                    <p>1.次日00:00-02:00更新昨日数据，02:30进行流量扣除；</p>
                                    <p>2.页面展示时间均为(GMT+08:00)时区。</p>
                                    <i class="el-icon-info" slot="reference"></i>
                                </el-popover>
                            </span>
                        </span>
                        <div>
                            <span class="acout-progress-item-bar" @click="handleBuy">充值</span>
                        </div>

                    </div>
                    <el-progress :percentage="percentage" :color="percentage<100 ? '' : 'red'"></el-progress>
                </div>
            </el-col>
        </el-row>
        <div class=" title ">流量消耗情况</div>
        <div class="acout-list">
            <div class="acout-list-item">
                <div>昨日消耗（GB）</div>
                <span>{{ dataTime.day }}</span>
            </div>
            <div class="acout-list-item">
                <div>近7日消耗（GB）</div>
                <span>{{ dataTime.week }}</span>
            </div>
            <div class="acout-list-item">
                <div>近30日消耗（GB）</div>
                <span>{{ dataTime.month }}</span>
            </div>
        </div>
        <div class=" title ">
            流量消耗情况
            <span>
                <el-popover placement="top" width="400" trigger="hover">
                    <p>统计用户观看视频课程所产生的流量消耗，以及商家在后台预览、下载视频等行为也会消耗流量</p>
                    <i class="el-icon-info" style="color: #656565;" slot="reference"></i>
                </el-popover>
            </span>
        </div>

        <!-- 表格部分 -->
        <div class="table">
            <div class="table-from">
                <el-row>
                    <el-col :span="10">
                        <div class="table-from-item">
                            <span>提交时间</span>
                            <el-date-picker v-model="times" type="daterange" range-separator="至"
                                start-placeholder="开始日期" end-placeholder="结束日期" @change="changeTime"
                                value-format="yyyy-MM-dd">
                            </el-date-picker>
                        </div>
                    </el-col>
                    <!-- <el-col :span="7">
                        <div class="table-from-item">
                            <span>课程标题</span>
                            <el-input placeholder="请输入课程标题" v-model="searchObj.title"></el-input>
                        </div>
                    </el-col> -->
                    <el-col :span="2">
                        <el-button type="primary" @click="resetSearch">重置</el-button>
                    </el-col>
                    <el-col :span="2">
                        <el-button type="primary" @click="searchBtn">查询</el-button>
                    </el-col>
                    <el-col :span="2">
                        <el-button type="primary" @click="exportExcel">导出</el-button>
                    </el-col>
                </el-row>


            </div>

            <div class="table-body">
                <el-table :data="tableData" style="width: 100%"
                    :header-cell-style="{ background: '#F5F7FA', color: '#454D53' }">
                    <el-table-column v-for="(item, index) in headerList" :prop="item.prop" :label="item.label"
                        :width="item.width" :show-overflow-tooltip="item.tooltip">
                        <template slot-scope="scope">
                            <!-- <el-popover trigger="hover" placement="top">
                            </el-popover> -->
                            <div v-if="item.prop == 'flow'">{{ scope.row[item.prop] }}GB</div>
                            <div v-else>{{ scope.row[item.prop] }}</div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <!-- 分页 -->
            <div class="table-footer">
                <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="searchObj.page" :page-sizes="[10, 20, 30, 40]" :page-size="searchObj.page_size"
                    layout="total, sizes, prev, pager, next, jumper" :total="total_count">
                </el-pagination>
            </div>
        </div>

    </div>
</template>
<script>
import { commentData } from '../data'
import apis from '../../api/api'
	import * as dayjs from 'dayjs'
import {
    mapState,
    mapMutations,
    mapActions
} from 'vuex'
export default {
    name: "storCenter",
    mixins: [commentData],
    data() {
        return {
            times: [],// 搜索时间范围
            total_count:0,//总条数
            dataTime:{},//流量消耗情况
            ConsumeInfo:{},//余量管理
            searchObj: {// 搜索条件
                page: 1,
                page_size: 10,
                title: '',
                start_date: '',
                end_date: '',

            },
            tableData: [{
                product_title: '2016-05-02',
                user: '王小虎',
                comment: '上海市普陀区金沙江路 1518 弄',
                score: 9.5,
                ty_name: '视频',
            }]
        }
    },
    computed: {
        percentage(){
            let num = (this.ConsumeInfo.use / (this.ConsumeInfo.total / 100)).toFixed(2);
            if(num == 'NaN'){
                return 0;
            }
            return Number(num);
        }
    },
    mounted() {
        this.getConsume()
        this.getDataList()
        this.getConsumeInfo()
    },
    methods: {
        ...mapActions('export', ['createExportAPI']),
        // 获取数据列表
        getConsume(){//流量消耗情况
            apis.getConsume().then(res => {
                this.dataTime = res
                console.log('getConsume', res)
            })
        },
        getDataList() {//获取流量消耗列表
            apis.ConsumeList(this.searchObj).then(res => {
                console.log('getConsumeList', res)
                this.tableData = res.list;
                this.total_count = res.page_info.total_count;
            })
        },
        getConsumeInfo() {//获取余量管理
            apis.ConsumeInfo(3).then(res => {
                console.log('getConsumeInfo', res)
                this.ConsumeInfo = res;
            })
        },
        handleLog(){// 变更记录
            this.$emit('updateType',2 )
        },
        handleBuy(){//充值
            this.$emit('updateType',3 )
        },
        // 搜索时间范围
        changeTime() {
            this.searchObj.start_date = this.times && this.times.length ? this.times[0] : ''
            this.searchObj.end_date = this.times && this.times.length ? this.times[1] : ''
        },
        // 查询按钮
        searchBtn() {
            console.log('点击查询', this.searchObj);
            this.searchObj.page = 1;
            this.getDataList()
        },
        // 导出按钮
        exportExcel() {

            let queryParams = ''
            // const searchObj = {}
            // for (const key in this.searchObj) {
            //     if (this.searchObj[key]) {
            //         searchObj[key] = this.searchObj[key]
            //     }
            // }
            let objPathData = {
                '/': 1,
                '/ks/': 2
            }
            // searchObj.comeFrom = objPathData[this.staticPath]
            this.$confirm('5分钟内仅可导出一次,导出后可在导出记录中查看导出进度,导出成功的数据请在24小时内下载', '导出提示', {
                distinguishCancelAndClose: true,
                confirmButtonText: '导出',
                cancelButtonText: '取消',
                customClass: ''
            })
                .then(async () => {
                    await this.createExportAPI({
                        type: 12, // 1用户订单 2退款订单 3申诉订单 4发货订单 5线索订单
                        search_params: {
                            ...this.searchObj,
                            excel: 1,
                        }
                    })
                    this.$router.push({
                        path: this.staticPath + "exportHistory"
                    })
                })
        },
        // 切换每页条数
        handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
            this.searchObj.page_size = val;
            this.getDataList()
        },
        // 切换当前页
        handleCurrentChange(val) {
            console.log(`当前页: ${val}`);
            this.searchObj.page = val;
            this.getDataList();
        },
        //重置
        resetSearch() {
            this.$set(this.searchObj, 'page', 1)
            this.$set(this.searchObj, 'title', '')
            this.$set(this.searchObj, 'start_date', '')
            this.$set(this.searchObj, 'end_date', '')
            this.times = []
            this.getDataList()
        },

    },
}
</script>
<style scoped lang="less">
.acout {
    .acout-title {
        display: flex;
        align-items: center;
        justify-content: space-between;

        span {
            font-size: 12px;
            color: #006cf6;
            cursor: pointer;
        }
    }

    .acout-progress {
        white-space: nowrap;
        font-size: 14px;
        color: #606266;
        margin-right: 12px;

        .acout-progress-item {
            display: flex;
        }

        .acout-progress-item-bar {
            margin-left: 25px;
            color: blue;
            cursor: pointer;
        }
    }

    .acout-list {
        display: flex;
        align-items: center;
        gap: 30px;

        .acout-list-item {
            padding: 15px 30px 15px 20px;
            background-color: #f0f0f0;

            div {
                margin-bottom: 10px;
                font-size: 14px;
                color: #585858;
            }

            >span {

                font-size: 16px;
                font-weight: 500;
            }
        }
    }

    .table {
        .table-from {
            .table-from-item {
                margin-right: 20px;
                display: flex;
                align-items: center;
                margin-bottom: 10px;

                span {
                    margin-right: 10px;
                    font-size: 14px;
                    color: #606266;
                    white-space: nowrap;
                }
            }
        }

        .table-footer {
            display: flex;
            justify-content: center;
            margin-top: 30px;
        }

    }
}

.title {
    font-size: 16px;
    font-weight: 600;
    color: #37383c;
    margin: 20px 0;
}
</style>